import { render, staticRenderFns } from "./CustomRegionDropdown.vue?vue&type=template&id=b6e00ae6&scoped=true"
import script from "./CustomRegionDropdown.vue?vue&type=script&lang=js"
export * from "./CustomRegionDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomRegionDropdown.vue?vue&type=style&index=0&id=b6e00ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e00ae6",
  null
  
)

export default component.exports